import React, { useEffect, useState } from "react";
import AppModal from "./AppModal";

const CustomerModal = ({
  show,
  setShow,
  editData,
  viewMode = false,
}) => {
  const initialState = {
    customer_name: "",
    company_name: "",
    gst_number: "",
    phone: "",
    email: "",
    customer_type: "Regular",
    balance_type: "Receivable",
    opening_balance: "",
    gst_status: "Unregistered / Consumer",
    birth_date: "",
    anniversary_date: "",
    billing_address: "",
    shipping_address: "",
    same_as_billing: false,
    status: "Active",
  };

  const [formData, setFormData] = useState(initialState);

  // Edit Data Fill
  useEffect(() => {
    if (editData) {
      setFormData({
        ...initialState,
        ...editData,
      });
    } else {
      setFormData(initialState);
    }
  }, [editData, show]);

  // Handle Change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      if (value.length > 10) return;
    }

    if (name === "same_as_billing") {
      setFormData({
        ...formData,
        same_as_billing: checked,
        shipping_address: checked
          ? formData.billing_address
          : "",
      });

      return;
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      size="modal-lg"
      title={
        viewMode
          ? "View Customer"
          : editData
            ? "Edit Customer"
            : "Add Party"
      }
      footer={
        <>
          <button
            className="btn btn-danger"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>

          {!viewMode && (
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {editData
                ? "Update Customer"
                : "Create Party"}
            </button>
          )}
        </>
      }
    >
      <form>
        <div className="row">
          {/* Customer Name */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Customer Name{" "}
              <span className="text-danger">*</span>
            </label>

            <input
              type="text"
              className="form-control"
              name="customer_name"
              placeholder="Enter customer name"
              value={formData.customer_name}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Company Name */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Company Name
            </label>

            <input
              type="text"
              className="form-control"
              name="company_name"
              placeholder="Enter company name"
              value={formData.company_name}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* GST Number */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              GST Number
            </label>

            <input
              type="text"
              className="form-control"
              name="gst_number"
              placeholder="Enter GST number"
              value={formData.gst_number}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Phone */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Phone Number{" "}
              <span className="text-danger">*</span>
            </label>

            <input
              type="number"
              className="form-control"
              name="phone"
              placeholder="Enter phone number"
              value={formData.phone}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Email */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Email Address
            </label>

            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter email address"
              value={formData.email}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Customer Type */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Customer Type
            </label>

            <select
              className="form-select"
              name="customer_type"
              value={formData.customer_type}
              onChange={handleChange}
              disabled={viewMode}
            >
              <option value="Regular">Regular</option>
              <option value="Wholesale">
                Wholesale
              </option>
              <option value="Retail">Retail</option>
            </select>
          </div>

          {/* Balance Type */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Balance Type
            </label>

            <select
              className="form-select"
              name="balance_type"
              value={formData.balance_type}
              onChange={handleChange}
              disabled={viewMode}
            >
              <option value="Receivable">
                Receivable
              </option>
              <option value="Payable">Payable</option>
            </select>
          </div>

          {/* Opening Balance */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Opening Balance
            </label>

            <input
              type="number"
              className="form-control"
              name="opening_balance"
              placeholder="0"
              value={formData.opening_balance}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* GST Status */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              GST Status
            </label>

            <select
              className="form-select"
              name="gst_status"
              value={formData.gst_status}
              onChange={handleChange}
              disabled={viewMode}
            >
              <option value="Unregistered / Consumer">
                Unregistered / Consumer
              </option>

              <option value="Registered Business">
                Registered Business
              </option>
            </select>
          </div>

          {/* Birth Date */}
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Birth Date
            </label>

            <input
              type="date"
              className="form-control"
              name="birth_date"
              value={formData.birth_date}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Anniversary Date */}
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Anniversary Date
            </label>

            <input
              type="date"
              className="form-control"
              name="anniversary_date"
              value={formData.anniversary_date}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Billing Address */}
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Billing Address
            </label>

            <textarea
              rows="4"
              className="form-control"
              name="billing_address"
              placeholder="Enter billing address"
              value={formData.billing_address}
              onChange={handleChange}
              disabled={viewMode}
            ></textarea>
          </div>

          {/* Shipping Address */}
          <div className="col-md-6 mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <label className="form-label">
                Shipping Address
              </label>

              <div className="form-check mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="same_as_billing"
                  checked={formData.same_as_billing}
                  onChange={handleChange}
                  disabled={viewMode}
                  id="sameAddress"
                />

                <label
                  className="form-check-label mt-0"
                  htmlFor="sameAddress"
                >
                  Same As Billing
                </label>
              </div>
            </div>

            <textarea
              rows="4"
              className="form-control"
              name="shipping_address"
              placeholder="Enter shipping address"
              value={formData.shipping_address}
              onChange={handleChange}
              disabled={
                viewMode || formData.same_as_billing
              }
            ></textarea>
          </div>

          {/* Status */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Status</label>

            <select
              className="form-select"
              name="status"
              value={formData.status}
              onChange={handleChange}
              disabled={viewMode}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </form>
    </AppModal>
  );
};

export default CustomerModal;